import { v1Delete } from '@/lib/api';

export const MASTER_CODE_PATTERN = /^[A-Za-z0-9_-]+$/;
const MASTER_NAME_ALLOWED = /^[\p{L}\p{N} .'\-/()&]+$/u;

export function validateMasterCode(code) {
  const trimmed = (code || '').trim();
  if (!trimmed) return { ok: false, message: 'Code is required.' };
  if (!MASTER_CODE_PATTERN.test(trimmed)) {
    return { ok: false, message: 'Code may only contain letters, numbers, underscores, and hyphens.' };
  }
  return { ok: true, value: trimmed };
}

export function validateMasterDisplayName(name) {
  const trimmed = (name || '').trim();
  if (!trimmed) return { ok: false, message: 'Display name is required.' };
  if (!/[A-Za-z\u00C0-\u024F\u1E00-\u1EFF]/u.test(trimmed)) {
    return { ok: false, message: 'Display name must contain at least one letter.' };
  }
  if (!MASTER_NAME_ALLOWED.test(trimmed)) {
    return { ok: false, message: "Display name may only contain letters, numbers, spaces, and . ' - / & ( )." };
  }
  return { ok: true, value: trimmed };
}

function normalizeMasterKey(value) {
  return (value || '').trim().toLowerCase();
}

/** Case-insensitive code uniqueness against loaded master-data rows. */
export function validateMasterCodeUnique(code, items, { excludeId, entityLabel = 'Item' } = {}) {
  const key = normalizeMasterKey(code);
  if (!key) return { ok: true, value: (code || '').trim() };
  const conflict = (items || []).find(
    (item) => item.id !== excludeId && normalizeMasterKey(item.code) === key,
  );
  if (conflict) {
    return { ok: false, message: `${entityLabel} code '${(code || '').trim()}' already exists.` };
  }
  return { ok: true, value: (code || '').trim() };
}

/** Case-insensitive display-name uniqueness against loaded master-data rows. */
export function validateMasterNameUnique(name, items, { excludeId, entityLabel = 'Item' } = {}) {
  const key = normalizeMasterKey(name);
  if (!key) return { ok: true, value: (name || '').trim() };
  const conflict = (items || []).find(
    (item) => item.id !== excludeId && normalizeMasterKey(item.name) === key,
  );
  if (conflict) {
    return { ok: false, message: `${entityLabel} name '${(name || '').trim()}' already exists.` };
  }
  return { ok: true, value: (name || '').trim() };
}

/** Map backend 409 "already exists" copy to the conflicting master-data field. */
export function masterDuplicateConflictField(detail) {
  if (typeof detail !== 'string') return null;
  if (!/already exists/i.test(detail)) return null;
  if (/\bcode\b/i.test(detail)) return 'code';
  if (/\bname\b/i.test(detail)) return 'name';
  return null;
}

export async function softDeleteMany(apiPath, ids) {
  const unique = [...new Set(ids)].filter(Boolean);
  if (unique.length === 0) return { ok: 0, failed: 0 };
  const results = await Promise.allSettled(
    unique.map((id) => v1Delete(`${apiPath}/${id}`)),
  );
  const ok = results.filter((r) => r.status === 'fulfilled').length;
  return { ok, failed: results.length - ok };
}
